if not App.angularApp?
    return

NUMBER_REGEXP = /^(?:\d+\.?|\d*\.\d+)$/

App.angularApp.directive 'mfIsNotNegative', () ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>
            ngModel.$validators.mfIsNotNegative = (modelValue, viewValue) =>
                if ngModel.$isEmpty(modelValue)
                    return true

                if NUMBER_REGEXP.test(viewValue) and viewValue >= 0
                    return true

                return false
    }
